import React from "react";
import Button from "@mui/material/Button";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import UserModalComponent from "./userModal";
import CheckIcon from "@mui/icons-material/Check";
import LoaderIndicator from "../../Utility/loading";
import LockResetIcon from "../../assets/new icons/user profile/reset password.svg";
import trashSvg from "../../assets/new icons/trash.svg";
import CloseIcon from "@mui/icons-material/Close";

import { useHistory, useLocation } from "react-router-dom";
import AdminUpdatePasswordModal from "../Models/changePassword";
import { useEffect, useState } from "react";
import DeleteModal from "../Models/Delete/DeleteModal";

import {
  EditButton,
  fontFamily,
  paddingAndMargin,
  paginationstyle,
  screenHeaderStyle,
  searchBoxStyle,
  UpperLowerText,
  useSharedValue,
} from "../Constants/constants";
import { BASE_URL } from "../../App_Settings/app_settings";
import { formatDate } from "../../Utility/utility";
import {
  ConditionalPagination,
  paginationStyles,
  useDynamicRowsPerPage,
} from "../../utils/paginationUtils";
import { getUserIdFromLocalStorage } from "../../API_Endpoints/APIEndpoints";
import UserImportModal from "../UserImport/UserImportModal";

const columns = [
  { field: "firstName", headerName: "FIRST NAME" },
  { field: "lastName", headerName: "LAST NAME" },
  { field: "email", headerName: "EMAIL" },
  { field: "roles", headerName: "ROLES" },
  { field: "defaultBusinessUnit", headerName: "DEFAULT CLIENT" },
  { field: "createdBy", headerName: "Created By", type: "string" },
  { field: "createdDate", headerName: "Created Date", type: "string" },
  { field: "modifiedBy", headerName: "Modified By", type: "string" },
  { field: "modifiedDate", headerName: "Modified Date", type: "string" },
  { field: "mfaEnabled", headerName: "MFA ENABLED" },
  { field: "isSuspended", headerName: "ACTIVE" },
  { field: "functions", headerName: "" },
];

export default function UserRoleProfile() {
  const location = useLocation();
  const organizationId = location.state?.organizationId;
  const [searchValue, setSearchValue] = React.useState("");
  const [selectDeletedItem, setSelectDeletedItem] = useState(null);
  const [isInputActive, setInputActive] = React.useState(false);
  const [editingData, setEditingData] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [rows, setRows] = React.useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);
  // Reset password modal state
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [resetTargetUser, setResetTargetUser] = useState(null);

  const [title, setTitle] = useState();
  const [healthStatus, setHealthStatus] = useState(null);
  const [requestStatus, setRequestStatus] = useState(null);
  const history = useHistory();
  const [startIndex, setStartIndex] = useState(0); // Initial rows per page value
  const [currentPage, setCurrtPage] = useState(1); // Current page number
  const { ref: scrollContainerRef, rowsPerPage: dynamicRowsPerPage } = useDynamicRowsPerPage();
  const [endIndex, setEndIndex] = useState(dynamicRowsPerPage);
  const {
    numberOfSelectedRows,
    updateRowNumberOfPages,
    defaultUser,
    defaultOrganization,
    formatBusinessUnitLabel,
  } = useSharedValue();
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  // Excel Import states
  const [showImportModal, setShowImportModal] = useState(false);
  const [availableRoles, setAvailableRoles] = useState([]);
  const [availableBusinessUnits, setAvailableBusinessUnits] = useState([]);
  const [availableOrganizations, setAvailableOrganizations] = useState([]);

  // Reusable function to fetch users data
  const fetchUsersData = async () => {
    setLoading(true);
    const userDataJSON = localStorage.getItem("token");

    if (userDataJSON) {
      const userData = JSON.parse(userDataJSON);

      // Priority: route-passed organizationId > SuperAdmin's top-bar selected org > own org
      const targetOrgId =
        organizationId || (isSuperAdmin && defaultOrganization?.id) || userData.organizationId;

      try {
        // Fetching data from the backend server
        const response = await fetch(`${BASE_URL}/users/getAllUsers/${targetOrgId}`, {
          headers: {
            Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          console.log("Fetched Users Data:", defaultUser);
          setRows(
            data.filter((item) => {
              // Base condition - not deleted
              if (item.isDeleted) return false;

              // Local search filter (search box on the page)
              const matchesLocalSearch =
                searchValue === "" ||
                item.firstName.toLowerCase().includes(searchValue.toLowerCase()) ||
                item.lastName.toLowerCase().includes(searchValue.toLowerCase()) ||
                item.email.toLowerCase().includes(searchValue.toLowerCase());

              // Global user filter (Search User dropdown) - match by user details
              const matchesGlobalUser =
                !defaultUser ||
                // item.id === defaultUser.id ||
                // item.firstName.toLowerCase().includes(defaultUser.firstName?.toLowerCase() || '') ||
                // item.lastName.toLowerCase().includes(defaultUser.lastName?.toLowerCase() || '') ||
                item.email.toLowerCase().includes(defaultUser.email?.toLowerCase() || "");

              return matchesLocalSearch && matchesGlobalUser;
            })
          );
        } else {
          console.error("Error fetching users:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchUsersData();
  }, [searchValue, organizationId, defaultUser, defaultOrganization, isSuperAdmin]);

  // Load data for Excel import
  useEffect(() => {
    const loadImportData = async () => {
      try {
        const userDataJSON = localStorage.getItem("token");
        if (!userDataJSON) return;

        const userData = JSON.parse(userDataJSON);
        const token = getUserIdFromLocalStorage().token;

        // Load roles
        const rolesResponse = await fetch(`${BASE_URL}/RolePermission/roles`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (rolesResponse.ok) {
          const rolesData = await rolesResponse.json();
          setAvailableRoles(rolesData);
        }

        // Load business units
        const targetOrgId = organizationId || userData.organizationId;
        const { getBusinessUnits } = await import("../../Utility/utility");
        const businessUnitsData = await getBusinessUnits(targetOrgId);
        setAvailableBusinessUnits(businessUnitsData.filter((bu) => !bu.isDeleted));

        // Load organizations (if super admin)
        if (isSuperAdmin) {
          const orgResponse = await fetch(
            `${BASE_URL}/Organization/${userData.userId}/${userData.organizationId}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          if (orgResponse.ok) {
            const orgData = await orgResponse.json();
            setAvailableOrganizations(orgData.filter((org) => org && org.id && org.name));
          }
        }
      } catch (error) {
        console.error("Error loading import data:", error);
      }
    };

    loadImportData();
  }, [organizationId, isSuperAdmin]);

  useEffect(() => {
    setCurrtPage(1);
    setStartIndex(0);
    setEndIndex(dynamicRowsPerPage);
  }, [dynamicRowsPerPage]);

  const handlePageChange = (event, newPage) => {
    setCurrtPage(newPage);
    setStartIndex((parseInt(newPage) - 1) * dynamicRowsPerPage);
    setEndIndex((parseInt(newPage) - 1) * dynamicRowsPerPage + dynamicRowsPerPage);
  };

  let totalPages = Math.ceil(rows.length / dynamicRowsPerPage);

  const { isMenuOpen } = useSharedValue();

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setEditingData(null);
    setOpen(false);
    // Remove window.location.reload() - this was causing the page to reload unnecessarily
  };

  const handleEdit = (row) => {
    setEditingData(row);
    handleOpen();
  };

  // Open reset password modal for a specific user
  const handleOpenResetPassword = (row) => {
    setResetTargetUser(row);
    setShowResetPassword(true);
  };

  const handleCloseResetPassword = () => {
    setShowResetPassword(false);
    setResetTargetUser(null);
  };

  // Admin resetting their own account — backend (isSelfChange=true) requires currentPassword
  const isResettingOwnAccount =
    resetTargetUser?.id?.toLowerCase() === getUserIdFromLocalStorage().userId?.toLowerCase();

  // Use same change password endpoint used in profile settings
  const handleSavePassword = (data) => {
    const userDataJSON = localStorage.getItem("token");
    if (userDataJSON) {
      const userData = JSON.parse(userDataJSON);
      //api calls to post the data
      return fetch(`${BASE_URL}/users/changepassword`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
        },
        body: JSON.stringify({
          userId: resetTargetUser.id,
          organizationId: resetTargetUser.organizationId,
          newPassword: data.password,
          // Required by backend when admin resets their own account (isSelfChange=true)
          ...(isResettingOwnAccount && { currentPassword: data.currentPassword }),
        }),
      })
        .then((response) => {
          if (response.ok) {
            return response.json(); // Parse JSON if response is OK
          } else {
            return response.json().then((errData) => {
              alert(errData?.message || `Request failed with status ${response.status}`);
              throw new Error(errData?.message || `Request failed with status ${response.status}`);
            });
          }
        })
        .then((data) => {
          if (data) {
            alert("The password has been updated successfully!");
            handleCloseResetPassword();
          }
        });
    } else {
      alert(
        "There seems to be an issue with the change password feature. Could you please log out, log back in, and try again?"
      );
    }
  };

  const handleSave = (newRow) => {
    const userDataJSON = localStorage.getItem("token");

    if (userDataJSON) {
      const userData = JSON.parse(userDataJSON);

      // Set processing to true immediately
      setIsProcessing(true);

      if (editingData) {
        const data = {
          userId: editingData.id,
          firstName: newRow.firstName,
          lastName: newRow.lastName,
          email: newRow.email,
          isActive: newRow.activeValue,
          mobileNumber: newRow.mobileNumber,
          modifiedBy: userData.userName,
          organizationId: isSuperAdmin ? newRow.organizationId : userData.organizationId,
          mfaEnabled: newRow.mfaEnabled || false,
          mfaEmail: newRow.mfaEmail || false,
          mfaMobile: newRow.mfaMobile || false,
          maxConcurrentSessions: newRow.maxConcurrentSessions || 1,
          roles: newRow.roles,
          businessUnits: newRow.businessUnits,
        };

        fetch(`${BASE_URL}/Users`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
          },
          body: JSON.stringify(data),
        })
          .then((response) => {
            if (!response.ok) {
              handleClose();
              alert(`Error: Unable to update the user profile. Status: ${response.status}`);
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json();
          })
          .then((data) => {
            setIsProcessing(false);
            if (data && data.requiresVerification) {
              alert(
                `User profile updated. ${data.message || "A verification email and/or SMS has been sent to the user. They must re-verify before they can log in."}`
              );
            } else {
              alert("User Profile updated successfully");
            }
            handleClose();
            // Refresh the users data to show updated information
            fetchUsersData();
          })
          .catch((error) => {
            setIsProcessing(false);
            console.error("Error updating user profile:", error);
          });

        setEditingData(null);
      } else {
        const data = {
          firstName: newRow.firstName,
          lastName: newRow.lastName,
          email: newRow.email,
          password: newRow.password,
          isActive: newRow.activeValue,
          createdBy: userData.userName,
          mobileNumber: newRow.mobileNumber,
          organizationId: isSuperAdmin ? newRow.organizationId : userData.organizationId,
          mfaEnabled: newRow.mfaEnabled || false,
          mfaEmail: newRow.mfaEmail || false,
          mfaMobile: newRow.mfaMobile || false,
          maxConcurrentSessions: newRow.maxConcurrentSessions || 1,
          roles: newRow.roles,
          businessUnits: newRow.businessUnits,
        };
        fetch(`${BASE_URL}/Users`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
          },
          body: JSON.stringify(data),
        })
          .then((response) => {
            if (!response.ok) {
              return response.text().then((errorText) => {
                alert(
                  `Error: Unable to create the user profile. ${errorText || `Status: ${response.status}`}`
                );
                throw new Error(`HTTP error! Status: ${response.status}`);
              });
            }
            return response.json();
          })
          .then((data) => {
            setIsProcessing(false);
            if (data && data.requiresVerification) {
              alert(
                "New user profile created successfully. A verification email and SMS have been sent to the user. They must verify their email and mobile number before they can log in."
              );
            } else {
              alert("New user profile created successfully");
            }
            handleClose();
            // Refresh the users data to show the new user from server
            fetchUsersData();
          })
          .catch((error) => {
            setIsProcessing(false);
            console.error("Error creating new user profile:", error);
          });
      }
    }
  };

  useEffect(() => async () => {
    // Fetch users based on organization ID
    const response = await fetch(
      `${BASE_URL}/users/${getUserIdFromLocalStorage().userId}/${getUserIdFromLocalStorage().organizationId}`,
      {
        headers: {
          Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
        },
      }
    );
    if (response.ok) {
      const user = await response.json();

      if (user) {
        if (user.isSuperAdmin) {
          setIsSuperAdmin(user.isSuperAdmin);
        }
      } else {
      }
    } else {
      console.error("Failed to fetch users:", response.statusText);
    }
  });

  // Import modal handlers
  const handleImportClick = () => {
    setShowImportModal(true);
  };

  const handleImportClose = () => {
    setShowImportModal(false);
  };

  const handleImportComplete = (summary) => {
    // Only close the modal automatically when all users imported successfully
    // If there are errors, keep modal open so user can review them
    if (summary.errorCount === 0) {
      setShowImportModal(false);
    }
    // Refresh the users data to show any newly imported users
    fetchUsersData();
  };

  const handleDelete = () => {
    setIsPopupOpen(false);

    // Update the user's isActive status to false
    const userDataJSON = localStorage.getItem("token");
    if (userDataJSON) {
      const userData = JSON.parse(userDataJSON);

      // Find the selected user's complete data
      const selectedUser = rows.find((row) => row.id === selectDeletedItem);

      // Transform roles to match expected format - use userRoles instead of roles
      const transformedRoles =
        selectedUser.userRoles?.map((role) => ({
          roleId: role.roleId || role.id,
        })) || [];

      // Use the exact same structure as the working update function
      const data = {
        userId: selectDeletedItem,
        firstName: selectedUser.firstName,
        lastName: selectedUser.lastName,
        email: selectedUser.email,
        isActive: false, // This is the only difference - set to false for delete
        isDeleted: true,
        mobileNumber: selectedUser.mobileNumber,
        modifiedBy: userData.userName,
        organizationId: selectedUser.organizationId || userData.organizationId,
        roles: transformedRoles,
        businessUnits:
          selectedUser.businessUnits?.map((bu) => ({
            businessUnitId: bu.id || bu.businessUnitId,
            isDefault: bu.isDefault || false,
          })) || [],
      };

      console.log("🚨 DELETE USER PAYLOAD:", JSON.stringify(data, null, 2));

      fetch(`${BASE_URL}/Users`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
        },
        body: JSON.stringify(data),
      })
        .then(async (response) => {
          if (!response.ok) {
            // Try to get the error message from the response
            let errorMessage = `HTTP error! Status: ${response.status}`;
            try {
              const errorText = await response.text();
              console.log("🚨 Backend Error Response:", errorText);
              errorMessage = `Error: Unable to deactivate the user. Status: ${response.status}. Message: ${errorText}`;
            } catch (e) {
              console.log("Could not parse error response");
            }
            alert(errorMessage);
            throw new Error(errorMessage);
          }

          // Try to parse as JSON, if it fails, return the text
          const contentType = response.headers.get("content-type");
          if (contentType && contentType.includes("application/json")) {
            return response.json();
          } else {
            const textResponse = await response.text();
            console.log("🚨 Non-JSON Response:", textResponse);
            return { message: textResponse };
          }
        })
        .then(() => {
          // Update the local state to remove the user from the list
          setRows((prevRows) => prevRows.filter((row) => row.id !== selectDeletedItem));
          const updatedRows = rows.filter((row) => row.id !== selectDeletedItem);

          // Calculate the new total pages
          totalPages = Math.ceil(updatedRows.length / dynamicRowsPerPage);

          // Determine if the current page should be adjusted
          let newCurrentPage = currentPage;
          if (currentPage > totalPages) {
            newCurrentPage = totalPages;
          } else if (currentPage === totalPages && updatedRows.length % dynamicRowsPerPage === 0) {
            newCurrentPage = currentPage - 1 > 0 ? currentPage - 1 : 1;
          }

          // Update the current page
          setCurrtPage(newCurrentPage);

          // Calculate and update the start and end indices
          const startIndex = (newCurrentPage - 1) * dynamicRowsPerPage;
          let endIndex = startIndex + dynamicRowsPerPage;
          endIndex = endIndex > updatedRows.length ? updatedRows.length : endIndex;

          setStartIndex(startIndex);
          setEndIndex(endIndex);

          alert("User has been deleted successfully");
          // Refresh the users data to ensure consistency
          fetchUsersData();
        })
        .catch((error) => {
          console.error("Error deactivating user:", error);
        });
    }
  };

  const filteredRows = rows.filter(
    (row) =>
      (row.firstName?.toLowerCase() || "").includes(searchValue.toLowerCase()) ||
      (row.lastName?.toLowerCase() || "").includes(searchValue.toLowerCase()) ||
      (row.email?.toLowerCase() || "").includes(searchValue.toLowerCase())
  );
  return (
    <>
      <div className={screenHeaderStyle(isMenuOpen)}>
        <div
          style={{
            marginTop: paddingAndMargin.headerTopHeight,
            marginBottom: paddingAndMargin.headerBelowHeight,
            backgroundColor: "transparent",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <InputBase
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onFocus={() => setInputActive(true)}
            onBlur={() => setInputActive(false)}
            className={searchBoxStyle}
            inputProps={{ "aria-label": "Entity Search", style: { padding: "0 8px" } }}
            placeholder="Search Users"
            endAdornment={
              isInputActive || searchValue ? (
                <CloseIcon
                  style={{ cursor: "pointer", color: "var(--application-primary-color)" }}
                  onMouseDown={(e) => {
                    e.preventDefault(); // Prevent input blur
                    setSearchValue("");
                    setInputActive(false);
                  }}
                />
              ) : (
                <SearchIcon style={{ color: "var(--application-primary-color)" }} />
              )
            }
          />
          <div style={{ display: "flex", gap: "8px" }}>
            <Button
              onClick={() => {
                setOpen(true);
                setEditingData("");
                setTitle("Create New User Profile");
              }}
              className="review-btn-filled"
              variant="contained"
            >
              Add New User
            </Button>
            {!isSuperAdmin && (
              <Button onClick={handleImportClick} className="review-btn-filled" variant="contained">
                Import Users
              </Button>
            )}
          </div>
        </div>

        {/* Column Titles */}
        <div class="columntitlesRowStyle">
          {columns.map((column) => (
            <div
              key={column.field}
              class="columntitlesStyle"
              style={column.field === "functions" ? { flex: "0 0 110px", minWidth: "110px" } : {}}
            >
              <UpperLowerText text={column.headerName} />
            </div>
          ))}
        </div>

        {/* Main container for table with fixed height */}
        <div style={{ height: "calc(100vh - 220px)", display: "flex", flexDirection: "column" }}>
          {/* Header row - fixed, no scrolling */}
          <div style={{ flexShrink: 0 }}>{/* Header content already rendered above */}</div>

          {/* Scrollable rows container */}
          <div ref={scrollContainerRef} style={{ flex: 1, overflowY: "auto" }}>
            {loading ? (
              <div
                style={{
                  textAlign: "center",
                  fontSize: "18px",
                  color: "#555",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <LoaderIndicator />
              </div>
            ) : rows.length === 0 ? (
              <div
                style={{
                  textAlign: "center",
                  fontSize: "18px",
                  color: "#555",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                There are no users available.
              </div>
            ) : (
              <div>
                {/* Row Data */}
                {(isInputActive ? filteredRows : rows).slice(startIndex, endIndex).map((row) => (
                  <div
                    key={row.fileImportId}
                    className="columnRowStyle"
                    style={row.isDeleted ? { opacity: 0.45 } : {}}
                  >
                    {/* <div style={{ paddingRight: '10px', }}>
              <Checkbox size="small" title="Select" onChange={() => { }} style={{ color: '#2aa7e0' }} />
            </div> */}
                    {columns.map((column) => (
                      <div
                        title={
                          column.headerName === "Modified Date" && row[column.field] != null
                            ? formatDate(row[column.field])
                            : column.headerName === "Created Date"
                              ? formatDate(row[column.field])
                              : column.field === "defaultBusinessUnit"
                                ? formatBusinessUnitLabel(
                                    row.businessUnits?.find((bu) => bu.isDefault)
                                  )
                                : row[column.field]
                        }
                        key={column.field}
                        className="columnValuesStyle"
                        style={
                          column.field === "functions"
                            ? { flex: "0 0 110px", minWidth: "110px", overflow: "visible" }
                            : {}
                        }
                      >
                        {column.field === "isSystemAdministrator" ||
                        column.field === "isSuspended" ||
                        column.field === "isApprover" ? (
                          <div
                            style={{
                              display: "flex",
                              paddingLeft: column.field === "isSuspended" ? 15 : 0,
                            }}
                          >
                            {row[column.field] == false && (
                              <CheckIcon style={{ filter: "var(--icon-download-filter)" }} />
                            )}
                          </div>
                        ) : column.field === "mfaEnabled" ? (
                          <div style={{ display: "flex", alignItems: "center", paddingLeft: 15 }}>
                            {row.mfaEnabled ? (
                              <span
                                style={{
                                  backgroundColor: "#E8F5E9",
                                  padding: "2px 10px",
                                  borderRadius: "12px",
                                  fontSize: "11px",
                                  color: "#2E7D32",
                                  fontWeight: 500,
                                }}
                              >
                                ✓ Enabled
                              </span>
                            ) : (
                              <span
                                style={{
                                  backgroundColor: "#FFEBEE",
                                  padding: "2px 10px",
                                  borderRadius: "12px",
                                  fontSize: "11px",
                                  color: "#C62828",
                                  fontWeight: 500,
                                }}
                              >
                                Disabled
                              </span>
                            )}
                          </div>
                        ) : column.field === "roles" ? (
                          <div style={{ display: "flex", gap: "4px" }}>
                            {row.userRoles?.map((role, index) => (
                              <span key={index} className="valuesBackground">
                                {role.name}
                              </span>
                            ))}
                          </div>
                        ) : column.field === "defaultBusinessUnit" ? (
                          formatBusinessUnitLabel(row.businessUnits?.find((bu) => bu.isDefault))
                        ) : column.field === "functions" ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              gap: "10px",
                              marginLeft: "auto",
                            }}
                          >
                            <EditButton
                              onClick={() => {
                                handleEdit(row);
                                setTitle("Edit User Profile");
                              }}
                            />
                            <img
                              src={LockResetIcon}
                              alt="Reset password"
                              title="Reset password"
                              onClick={() => handleOpenResetPassword(row)}
                              style={{
                                // width: 20,
                                height: "24px",
                                cursor: "pointer",
                                margin: 0,
                                filter: "var(--icon-download-filter)",
                              }}
                            />
                            <img
                              title="Delete"
                              src={trashSvg}
                              alt="Delete"
                              style={{
                                // width: 18,
                                height: 18,
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setIsPopupOpen(true);
                                setSelectDeletedItem(row.id);
                              }}
                            />
                          </div>
                        ) : column.headerName === "Modified Date" && row[column.field] != null ? (
                          formatDate(row[column.field])
                        ) : column.headerName === "Created Date" ? (
                          formatDate(row[column.field])
                        ) : (
                          row[column.field]
                        )}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Delete Confirmation Modal */}
        <DeleteModal
          open={isPopupOpen}
          isDeleting={false}
          onClose={() => setIsPopupOpen(false)}
          onDelete={handleDelete}
        />

        {/* User Modal Component */}
        <UserModalComponent
          show={open}
          handleClose={() => setOpen(false)}
          onSave={handleSave}
          handleEdit={editingData}
          title={title}
          isLoading={loading}
          isSuperAdmin={isSuperAdmin}
        />

        {/* Reset Password Modal (Admin) */}
        <AdminUpdatePasswordModal
          show={showResetPassword}
          handleClose={handleCloseResetPassword}
          onSave={handleSavePassword}
          editingData={resetTargetUser}
          isAdminReset={!isResettingOwnAccount}
        />

        {/* Global Loader - shows when modal is closed and processing is true */}
        {!open && isProcessing && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <div
              style={{
                backgroundColor: "white",
                padding: "20px",
                borderRadius: "8px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <LoaderIndicator />
              <span style={{ fontFamily: fontFamily, color: "var(--application-primary-color)" }}>
                Processing...
              </span>
            </div>
          </div>
        )}

        {/* Excel Import Modal */}
        {!isSuperAdmin && (
          <UserImportModal
            show={showImportModal}
            onClose={handleImportClose}
            onImportComplete={handleImportComplete}
            availableRoles={availableRoles}
            availableBusinessUnits={availableBusinessUnits}
            availableOrganizations={availableOrganizations}
            currentUserOrganizationId={organizationId}
            isSuperAdmin={isSuperAdmin}
          />
        )}
      </div>
      <ConditionalPagination
        itemCount={rows.length}
        itemsPerPage={dynamicRowsPerPage}
        threshold={dynamicRowsPerPage}
        paginationProps={{
          page: currentPage,
          onChange: handlePageChange,
          style: paginationstyle,
          sx: paginationStyles,
          hidePrevButton: false,
          hideNextButton: false,
          showFirstButton: true,
          showLastButton: true,
        }}
      />
    </>
  );
}
